import { Article } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { M_Fieldset, M_InputTextField } from 'src/M_Components'

const setField = (field, value, setData) => {
    setData(prev => ({ ...prev, [field]: value }))
}

export const EblPartyNameInfo = ({ dataState, setDataState }) => {
    const { t } = useTranslation()

    return (
        <M_Fieldset
            labelInside
            label={
                <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                    <Article style={{ marginRight: '10px', scale: '1.3' }} />
                    {t('Information')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                    <div style={{ margin: '5px' }}>
                        <M_InputTextField
                            size="250px"
                            label={t('Internal Name')}
                            value={dataState?.InternalName || ''}
                            required
                            onChange={(e) => setField('InternalName', e.target.value, setDataState)}
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <M_InputTextField
                            size="250px"
                            label={t('eBL Name')}
                            value={dataState?.EblName || ''}
                            required
                            onChange={(e) => setField('EblName', e.target.value, setDataState)}
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px' }}>{t('Party Role')}</label>
                        <select
                            value={dataState?.PartyRole || ''}
                            onChange={(e) => setField('PartyRole', e.target.value, setDataState)}
                            style={{ minWidth: '250px', padding: '8px' }}
                        >
                            <option value="">{t('Select')}</option>
                            <option value="Shipper">{t('Shipper')}</option>
                            <option value="Consignee">{t('Consignee')}</option>
                        </select>
                    </div>
                </div>
            }
        />
    )
}
